/**
 * Emit hosts for the `sectional-note` analytics group — 1 function
 * lifted out of `analyticsScribeModel`'s effects so a call site can emit
 * without holding a Rematch `dispatch`. Every payload is the effect's own.
 */
import { trackLegacyEvent } from '@/lib/analytics/track-legacy-event';
import { SegmentActionName, SegmentObjectName } from '@/models/analytics/segment-names';

export function sectionalNoteEhrSectionSelected({
  isUnlinking,
  heidiSectionTitle,
  ehrSectionTitle,
}: {
  isUnlinking?: boolean;
  heidiSectionTitle?: string;
  ehrSectionTitle?: string;
}) {
  trackLegacyEvent({
    name: SegmentObjectName.SectionalNote,
    props: {
      action: SegmentActionName.SectionalNoteEhrSectionSelected,
      heidiSectionTitle,
      ehrSectionTitle,
      isUnlinking,
    },
  });
}
